<sn-data-list #list [fetchFn]="loadData">
  <sn-infinite-scroll class="h-100 overflow-auto">
    <sn-pull-to-refresh class="pull-to-refresh">
      <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="listTmpl"></ng-template>
      <ng-template
        [ngIf]="!list.dataSource.data.length && list.dataIsInited"
        [ngIfThen]="emptyTmpl"
      ></ng-template>
    </sn-pull-to-refresh>
  </sn-infinite-scroll>
</sn-data-list>

<ng-template #listTmpl>
  <mat-table [dataSource]="list" [dataSource]="list.dataSource.data" [trackBy]="trackBy">
    <ng-container matColumnDef="label">
      <mat-header-cell *matHeaderCellDef> Label </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.detections.length; else eventTmpls">
          <ng-container *ngFor="let detection of element.detections">
            {{ detection.label }}
          </ng-container>
        </ng-container>
        <ng-template #eventTmpls>
          <ng-container *ngFor="let event of element.events">
            {{ event.label }}
          </ng-container>
        </ng-template>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="type">
              <mat-header-cell class="camera-events-list-justify-content-center" *matHeaderCellDef> Rule Name </mat-header-cell>
        <mat-cell class="camera-events-list-justify-content-center" *matCellDef="let element">
        <ng-container *ngIf="element.detections.length; else eventTmpls">
          <ng-container *ngFor="let detection of element.detections">
            <ng-container *ngFor="let data of detection.metadata | keyvalue">
              <span *ngIf="data.key === 'ruleName'">
                {{ data.value }}
              </span>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #eventTmpls>
          <ng-container *ngFor="let event of element.events">
            <ng-container *ngFor="let data of event.metadata | keyvalue">
              <span *ngIf="data.key === 'type'">
                {{ data.value }}
              </span>
            </ng-container>
          </ng-container>
        </ng-template>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="timestamp">
              <mat-header-cell class="camera-events-list-justify-content-center" *matHeaderCellDef> Timestamp </mat-header-cell>
        <mat-cell class="camera-events-list-justify-content-center" *matCellDef="let element">
        {{ element.timestamp | fsFormatDate: 'medium' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="thumbnail">
              <mat-header-cell class="camera-events-list-justify-content-start" *matHeaderCellDef> Snapshot </mat-header-cell>
        <mat-cell class="camera-events-list-justify-content-center" *matCellDef="let element">
        <img 
          class="detectionImg" 
          *ngIf="isValidImageUrl(element.detectionsImageUrl) && !element.error"
          [src]="element.detectionsImageUrl" 
          alt="Detection Image" 
          (click)="onImageSelected(element.detectionsImageUrl)"
          (error)="element.error = true"
        >
        <img 
          class="detectionImg error-image" 
          *ngIf="(!isValidImageUrl(element.detectionsImageUrl) || element.error) && placeHolderImageUrl"
          [src]="placeHolderImageUrl" 
          alt="Detection Image Placeholder" 
          (click)="onImageSelected(placeHolderImageUrl)"
        >
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
              <mat-header-cell class="camera-events-list-justify-content-center" *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell class="camera-events-list-justify-content-center" *matCellDef="let item">
        <sn-action-list [items]="actions" [context]="item" alwaysExpand></sn-action-list>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columns"></mat-row>
  </mat-table>
</ng-template>
<ng-template #emptyTmpl>
  <sn-empty-state icon="cancel_presentation" title="No Results">
    No results match search criteria
  </sn-empty-state>
</ng-template>
